import { css, Theme } from '@emotion/react'

const sectionTitleStyle = css`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 18px;
  color: #454545;
  margin-bottom: 16px;
`

const gridStyle = css`
  display: flex;
  flex-direction: column;
`

const itemStyle = css`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  align-items: center;

  &:first-of-type {
    margin-top: 0;
  }
`

const labelStyle = css`
  font-family: 'Noto Sans', sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.2rem;
  color: #767676;
  width: 200px;
  flex-shrink: 0;
`

const valueStyle = (t: Theme) => css`
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.2rem;
  color: ${t.c.bc.text};
  flex: 1;
  min-height: 2.2rem;
`

export type UserViewData = {
  id: number
  loginId: string
  name: string
  roleName: string
}

type Props = {
  data: UserViewData
}

export const UserView = ({ data }: Props) => {
  return (
    <>
      <h3 css={sectionTitleStyle}>アカウント情報</h3>
      <div css={gridStyle}>
        <div css={itemStyle}>
          <span css={labelStyle}>ID</span>
          <span css={valueStyle}>{data.loginId}</span>
        </div>
        <div css={itemStyle}>
          <span css={labelStyle}>アカウント名</span>
          <span css={valueStyle}>{data.name}</span>
        </div>
        <div css={itemStyle}>
          <span css={labelStyle}>パスワード</span>
          <span css={valueStyle}>●●●●●</span>
        </div>
        <div css={itemStyle}>
          <span css={labelStyle}>権限</span>
          <span css={valueStyle}>{data.roleName}</span>
        </div>
      </div>
    </>
  )
}
